// extracted by mini-css-extract-plugin
export default {"Delimiter":"delimiter_Delimiter__W5l07"};